{
  "v11.journal.acteur_inconnu": "unknown actor",
  "v11.journal.auteurs.createur": "Creator or requester: {{qui}}",
  "v11.journal.auteurs.decideur": "Decider: {{qui}}",
  "v11.journal.auteurs.identites_distinctes": "Author and decider are two different people.",
  "v11.journal.auteurs.identites_identiques_signalees": "The same person created and decided: segregation of duties not respected.",
  "v11.journal.auteurs.inconnu": "not recorded",
  "v11.journal.auteurs.information_historique_insuffisante": "Not enough historical information to compare author and decider.",
  "v11.journal.auteurs.lecture_seule": "Read only: no decision is taken from the log.",
  "v11.journal.auteurs.non_applicable": "No decision in this event: authors and deciders do not apply.",
  "v11.journal.auteurs.titre": "Authors and deciders",
  "v11.journal.code.AUDIT_EXPORT_PERMISSION_REQUIRED": "This project's log is reserved to its owner and to the organisation's administration.",
  "v11.journal.code.CONTEXTE_INCOMPLET": "The context needed to check your rights is incomplete.",
  "v11.journal.code.DROIT_NON_TENU": "You do not hold the right required to read this log.",
  "v11.journal.code.JOURNAL_EXPORT_TROP_VOLUMINEUX": "More than 5,000 rows: narrow the filters before exporting.",
  "v11.journal.code.RESOURCE_UNAVAILABLE": "This project cannot be found in your organisation.",
  "v11.journal.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v11.journal.code.VALIDATION_ERROR": "Filters rejected by the server: check the result and the dates.",
  "v11.journal.code.evenement.RESOURCE_UNAVAILABLE": "This event cannot be found in this project.",
  "v11.journal.code.evenement.VALIDATION_ERROR": "Malformed event identifier.",
  "v11.journal.contexte.defaut": "Direct access: going back opens the project log without filters.",
  "v11.journal.contexte.repris": "Log filters and position kept: going back returns you where you were.",
  "v11.journal.contexte.titre": "Reading context",
  "v11.journal.etat.chargement": "Loading {{quoi}}…",
  "v11.journal.etat.erreur": "Could not read {{quoi}}.",
  "v11.journal.etat.reessayer": "Retry",
  "v11.journal.etat.refus": "Reading refused ({{quoi}}).",
  "v11.journal.evenement.depend": "Depends on reading the event.",
  "v11.journal.evenement.identifiant": "Identifier {{id}} · correlation {{correlation}}",
  "v11.journal.evenement.immuable": "A log event is never edited or deleted.",
  "v11.journal.evenement.masques": "Source not accessible: titles and excerpts are hidden.",
  "v11.journal.evenement.qui_quoi": "{{acteur}} · {{action}} · {{cible}}",
  "v11.journal.evenement.quoi": "the event",
  "v11.journal.evenement.resultat": "Result: {{resultat}}",
  "v11.journal.evenement.sans_correlation": "none",
  "v11.journal.evenement.titre": "Event",
  "v11.journal.evenement.titre_ecran": "Project event details",
  "v11.journal.export.annuler": "Cancel",
  "v11.journal.export.colonnes": "Columns: {{colonnes}}",
  "v11.journal.export.conservation": "Entries kept according to the retention policy; at most {{plafond}} rows per export.",
  "v11.journal.export.conservation_partielle": "Partial history: no entry kept before {{date}}.",
  "v11.journal.export.depend": "Depends on the export preview.",
  "v11.journal.export.echec": "The export failed.",
  "v11.journal.export.en_cours": "Exporting…",
  "v11.journal.export.ensemble": "Whole filtered set from the first row, never the displayed page.",
  "v11.journal.export.exporter": "Export",
  "v11.journal.export.expurgations": "Redacted values: {{cles}}",
  "v11.journal.export.fait": "{{n}} rows exported; the export is recorded in the log.",
  "v11.journal.export.masques": "Sources not accessible: their titles and excerpts are removed from the export.",
  "v11.journal.export.perimetre": "Project {{projet}} · whole retained period · times in UTC",
  "v11.journal.export.perimetre_periode": "Project {{projet}} · from {{du}} to {{au}} · times in UTC",
  "v11.journal.export.quoi": "the export preview",
  "v11.journal.export.session_expiree": "Your session has expired: sign in again, then restart the export.",
  "v11.journal.export.titre": "Export the project log",
  "v11.journal.export.trop_volumineux": "More than 5,000 rows: narrow the filters before exporting.",
  "v11.journal.export.volume": "{{n}} rows, CSV format, at most {{plafond}} rows.",
  "v11.journal.filtres.acteur": "Actor",
  "v11.journal.filtres.action": "Action",
  "v11.journal.filtres.appliquer": "Apply filters",
  "v11.journal.filtres.au": "To",
  "v11.journal.filtres.bornes": "From (included) to (excluded), in UTC.",
  "v11.journal.filtres.correlation": "Correlation",
  "v11.journal.filtres.dates_inversees": "The start date must be before the end date.",
  "v11.journal.filtres.du": "From",
  "v11.journal.filtres.objet_id": "Object (identifier)",
  "v11.journal.filtres.objet_type": "Object (type)",
  "v11.journal.filtres.resultat": "Result",
  "v11.journal.filtres.titre": "Filters",
  "v11.journal.habilitation.actuel_distinct": "Current authorisations are read in the project members: they may differ from the historical state.",
  "v11.journal.habilitation.droit": "Right examined: {{droit}} · reason {{motif}}",
  "v11.journal.habilitation.non_applicable": "No authorisation decision for this event.",
  "v11.journal.habilitation.non_conserve": "Profile at the time of the action: not kept.",
  "v11.journal.habilitation.roles": "Observed session roles (matched by actor, route and time, not certain): {{roles}}",
  "v11.journal.habilitation.sans_observation": "No matched authorisation observation.",
  "v11.journal.habilitation.titre": "Observed authorisation",
  "v11.journal.journal.titre": "Project audit log",
  "v11.journal.liens.acteur": "Actor profile page",
  "v11.journal.liens.chronologie": "Object timeline",
  "v11.journal.liens.correles": "Correlated events",
  "v11.journal.liens.exporter": "Export the log",
  "v11.journal.liens.exports_gouvernes": "Governed project exports",
  "v11.journal.liens.exports_gouvernes_a_venir": "Screen delivered with the exports wave.",
  "v11.journal.liens.habilitations_organisation": "Organisation authorisations",
  "v11.journal.liens.journal_organisation": "Organisation log",
  "v11.journal.liens.membres": "Project members",
  "v11.journal.liens.profil": "Actor's profile",
  "v11.journal.liens.retour_journal": "Back to the log",
  "v11.journal.liens.retour_projet": "Back to the project",
  "v11.journal.liens.sans_acteur": "Automatic actor: no person page.",
  "v11.journal.liens.sans_correlation": "No correlation for this event.",
  "v11.journal.liens.sans_objet": "This event targets no object.",
  "v11.journal.liens.sans_profil": "The profile at the time of the action is not kept.",
  "v11.journal.ligne": "{{quand}} · {{acteur}} · {{action}} · {{cible}} · {{resultat}}",
  "v11.journal.liste.examiner": "Examine {{action}}",
  "v11.journal.liste.fin": "End of the log.",
  "v11.journal.liste.masques": "Some sources are not accessible to you: their titles and excerpts are hidden.",
  "v11.journal.liste.ordre": "Most recent first.",
  "v11.journal.liste.position": "Rows {{de}} to {{a}} of {{total}}",
  "v11.journal.liste.quoi": "the log",
  "v11.journal.liste.suivante": "Next page",
  "v11.journal.liste.titre": "Log events",
  "v11.journal.liste.vide": "No event for these filters.",
  "v11.journal.perimetre.historique_partiel": "Partial history: no entry kept before {{date}}.",
  "v11.journal.perimetre.modele": "Model “{{libelle}}”, version {{version}}",
  "v11.journal.perimetre.projet": "Project {{projet}} · times in UTC",
  "v11.journal.perimetre.sans_modele": "No frozen model for this project.",
  "v11.journal.perimetre.titre": "Scope",
  "v11.journal.preuves.absente": "No hash for this audit row: evidence missing.",
  "v11.journal.preuves.empreinte": "Hash {{empreinte}} ({{algo}}) · key {{cle}}, {{statut}}",
  "v11.journal.preuves.expurge": "Sensitive content redacted.",
  "v11.journal.preuves.non_attestee": "Integrity not attested here: the chain is attested by the verifiable audit export.",
  "v11.journal.preuves.titre": "Evidence",
  "v11.journal.reference.source_hors_modele": "Historical type and identifier: {{objet}} (outside the item model).",
  "v11.journal.reference.source_presente": "Historical type and identifier: {{objet}}.",
  "v11.journal.reference.source_supprimee": "Historical type and identifier: {{objet}}.",
  "v11.journal.reference.titre": "Title: {{titre}}",
  "v11.journal.reference.titre_section": "Historical source",
  "v11.journal.reference.trace_conservee": "Source deleted since: the event trace is kept.",
  "v11.journal.resultat.echec": "Failure",
  "v11.journal.resultat.refus": "Refusal",
  "v11.journal.resultat.succes": "Success",
  "v11.journal.resultat.tous": "All",
  "v11.journal.sans_evenement": "Choose an event from the project log.",
  "v11.journal.sans_projet": "Choose a project to read its audit log.",
  "v11.journal.source.element": "{{titre}} · status {{statut}}",
  "v11.journal.source.ouvrir": "Open the source",
  "v11.journal.source.quoi": "the source",
  "v11.journal.source.vide": "Empty source."
}
